var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalCommisions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67510",
    "data-name": "Group 67510",
    transform: "translate(-1310 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22415",
    "data-name": "Rectangle 22415",
    width: 72,
    height: 72,
    transform: "translate(1310 756)",
    fill: "#ddf8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-badge-percent",
    transform: "translate(1326 772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67405",
    "data-name": "Group 67405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67404",
    "data-name": "Group 67404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80467",
    "data-name": "Path 80467",
    d: "M20,40a9.15,9.15,0,0,1-7.013-3.265,8.771,8.771,0,0,1-7.128-2.592,9.158,9.158,0,0,1-2.65-7.27A8.784,8.784,0,0,1,0,20a9.145,9.145,0,0,1,3.267-7.013A8.782,8.782,0,0,1,5.858,5.858a9.133,9.133,0,0,1,7.268-2.65A8.789,8.789,0,0,1,20,0a9.149,9.149,0,0,1,7.013,3.265,8.772,8.772,0,0,1,7.128,2.592,9.158,9.158,0,0,1,2.65,7.27A8.783,8.783,0,0,1,40,20a9.145,9.145,0,0,1-3.267,7.013,8.782,8.782,0,0,1-2.592,7.128,9.155,9.155,0,0,1-7.268,2.65A8.789,8.789,0,0,1,20,40Zm-6.878-6.54a3.128,3.128,0,0,1,2.413,1.127,5.832,5.832,0,0,0,8.93,0,3.137,3.137,0,0,1,2.693-1.117,5.83,5.83,0,0,0,6.313-6.313,3.127,3.127,0,0,1,1.117-2.695,5.827,5.827,0,0,0,0-8.927,3.13,3.13,0,0,1-1.117-2.7A5.832,5.832,0,0,0,27.16,6.527a3.117,3.117,0,0,1-2.695-1.115,5.832,5.832,0,0,0-8.93,0,3.153,3.153,0,0,1-2.693,1.117,5.833,5.833,0,0,0-6.313,6.313,3.127,3.127,0,0,1-1.117,2.7,5.827,5.827,0,0,0,0,8.927,3.13,3.13,0,0,1,1.117,2.695,5.832,5.832,0,0,0,6.312,6.313c.1-.008.188-.012.282-.012ZM15,13.333A1.667,1.667,0,1,0,16.667,15,1.667,1.667,0,0,0,15,13.333Zm10,10A1.667,1.667,0,1,0,26.667,25,1.667,1.667,0,0,0,25,23.333Zm-6.947,2.592,6.667-10a1.667,1.667,0,1,0-2.773-1.85l-6.667,10a1.667,1.667,0,0,0,2.773,1.85Z",
    fill: "#1d98b5"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCommisions);
export default __webpack_public_path__ + "static/media/total-commisions.06a401ac6a33f12857686fb089752cca.svg";
export { ForwardRef as ReactComponent };